import React from 'react';
import '../styles/SoldOut.css';
import SoldOutGrid from '../grids/SoldOutGrid';
import PeopleGrid from '../grids/PeopleGrid';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    soldOutTitle: "Sold Out Projects",
    trendBadge: "PRICES RISING MONTHLY",
    h2_1: "🚨 Don’t Miss Out—These Lots Are Already Sold! 🚨",
    p1: "The demand for paradise is soaring! The sold-out lot compounds featured below are proof that opportunities in Oaxaca’s stunning coastal region near Puerto Escondido won’t wait for you. Buyers just like you acted fast—and now they’re securing their futures in one of Mexico’s most sought-after locations.",
    bullet1: "📍 Prices are rising fast as more investors discover this hidden gem.",
    bullet2: "📍 Limited inventory remains—and every week, more lots are snapped up.",
    bullet3: "📍 Your dream of owning a slice of Oaxaca’s coast could slip away if you hesitate.",
    h2_2: "Act now before the next 'Sold Out' sign goes up!",
    p2: "👉 Explore our remaining available lots today and secure your piece of paradise at today’s prices. With breathtaking beaches, booming tourism, and endless potential, this is your chance to invest in a lifestyle that’s unforgettable and appreciating by the day.",
    p3: "Don’t let regret cost you more than action. ⏳ Time is the only thing you’ll lose by waiting.",
    realPeopleTitle: "Real Investments, Real People",
    h2_3: "Meet Your Future Neighbors—Visionaries Building a Nature-Led Community",
    p4: "The sold-out lots near Puerto Escondido weren’t just purchased—they were claimed by dreamers, adventurers, and families who share a vision: to create a thriving community rooted in nature, connection, and sustainable living. These are people who crave open skies, salty breezes, and the freedom to build a life where the outdoors isn’t just a view—it’s a way of living.",
    h2_4: "This isn’t just land. It’s the foundation of something extraordinary.",
    palm1: "🌴 Like-minded pioneers are already sketching plans for eco-friendly homes, shared gardens, and gathering spaces under the stars.",
    palm2: "🌴 Families will soon call this place home—imagine kids growing up with sandy toes, exploring tide pools, and learning from nature’s classroom.",
    palm3: "🌴 A community built by nature lovers, for nature lovers—where trails replace traffic, and neighbors become lifelong friends.",
    h2_5: "Why join them now?",
    point1: "👉 The best lots go first—those who secured theirs knew the value of acting early.",
    point2: "👉 Prices rise as the community grows—invest today, before demand outpaces supply.",
    point3: "👉 Be part of shaping the future—collaborate with others who value sustainability, adventure, and authenticity."
  },
  es: {
    soldOutTitle: "Proyectos Agotados",
    trendBadge: "PRECIOS SUBIENDO MENSUALMENTE",
    h2_1: "🚨 No Te Pierdas—¡Estos Lotes Ya Están Vendidos! 🚨",
    p1: "¡La demanda del paraíso se está disparando! Los complejos de lotes agotados que se muestran a continuación son prueba de que las oportunidades en la impresionante región costera de Oaxaca cerca de Puerto Escondido no esperarán por ti. Compradores como tú actuaron rápido—y ahora están asegurando su futuro en una de las ubicaciones más codiciadas de México.",
    bullet1: "📍 Los precios suben rápido mientras más inversionistas descubren esta joya oculta.",
    bullet2: "📍 El inventario limitado disminuye—cada semana se venden más lotes.",
    bullet3: "📍 Tu sueño de poseer un pedazo de la costa oaxaqueña podría esfumarse si dudas.",
    h2_2: "¡Actúa ahora antes que aparezca el próximo cartel de 'Agotado'!",
    p2: "👉 Explora nuestros lotes disponibles hoy y asegura tu porción de paraíso a precios actuales. Con playas impresionantes, turismo en auge y potencial ilimitado, esta es tu oportunidad de invertir en un estilo de vida inolvidable que se aprecia día a día.",
    p3: "No dejes que el arrepentimiento te cueste más que la acción. ⏳ El tiempo es lo único que perderás esperando.",
    realPeopleTitle: "Inversiones Reales, Personas Reales",
    h2_3: "Conoce a tus Futuros Vecinos—Visionarios Construyendo una Comunidad Guiada por la Naturaleza",
    p4: "Los lotes agotados cerca de Puerto Escondido no solo fueron comprados—fueron reclamados por soñadores, aventureros y familias que comparten una visión: crear una comunidad próspera arraigada en la naturaleza, conexión y vida sostenible. Estas son personas que anhelan cielos abiertos, brisas saladas y la libertad de construir una vida donde el aire libre no sea solo una vista—sino una forma de vivir.",
    h2_4: "Esto no es solo tierra. Es el cimiento de algo extraordinario.",
    palm1: "🌴 Pioneros afines ya están diseñando planes para hogares ecológicos, jardines compartidos y espacios de reunión bajo las estrellas.",
    palm2: "🌴 Familias pronto llamarán a este lugar hogar—imagina niños creciendo con pies arenosos, explorando pozas de marea y aprendiendo en el aula de la naturaleza.",
    palm3: "🌴 Una comunidad construida por amantes de la naturaleza, para amantes de la naturaleza—donde senderos reemplazan tráfico y vecinos se convierten en amigos para toda la vida.",
    h2_5: "¿Por qué unirte ahora?",
    point1: "👉 Los mejores lotes se van primero—quienes aseguraron el suyo sabían el valor de actuar temprano.",
    point2: "👉 Los precios suben con el crecimiento comunitario—invierte hoy, antes que la demanda supere la oferta.",
    point3: "👉 Sé parte del futuro—colabora con quienes valoran sostenibilidad, aventura y autenticidad."
  }
};

const Testimonials = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].soldOutTitle}</h1>
        <div className="trend-badge">
          {translations[language].trendBadge}
        </div>
        <h2>{translations[language].h2_1}</h2>
        <p>{translations[language].p1}</p>
        
        <div className="callout-box">
          <p>{translations[language].bullet1}</p>
          <p>{translations[language].bullet2}</p>
          <p>{translations[language].bullet3}</p>
        </div>

        <h2>{translations[language].h2_2}</h2>
        <p>{translations[language].p2}</p>
        <p>{translations[language].p3}</p>
      </div>

      <div className="sold-out-grid-main">
        <SoldOutGrid />
      </div>

      <div className="testimonial-text">
        <h1>{translations[language].realPeopleTitle}</h1>
        <h2>{translations[language].h2_3}</h2>
        <p>{translations[language].p4}</p>
        
        <h2>{translations[language].h2_4}</h2>
        <p>{translations[language].palm1}</p>
        <p>{translations[language].palm2}</p>
        <p>{translations[language].palm3}</p>

        <h2>{translations[language].h2_5}</h2>
        <p>{translations[language].point1}</p>
        <p>{translations[language].point2}</p>
        <p>{translations[language].point3}</p>
      </div>

      <div className="sold-out-grid-main">
        <PeopleGrid />

        <WhatsappCTA language={language}/>
                
      </div>
    </div>
  );
};

export default Testimonials;


